<style lang="scss" scoped>
.asset-page {
    padding: 16px;
    background: #fff;
    min-height: 400px;

    /* 窄屏适配 */
    @media (max-width: 600px) {
        padding: 10px;
    }
}
</style>

<style lang="scss">
/* append-to-body 弹窗脱离组件作用域：宽度由 c-el-dialog(96%) 自适应，修饰类单独封顶 */
.asset-dialog--binding { max-width: 560px; }
.asset-dialog--ending { max-width: 430px; }
.asset-dialog--help { max-width: 620px; }
</style>

<template>
    <div class="asset-page">
        <!-- 工具栏：左侧主操作（新增/导入/变更日志/功能说明），右侧筛选/查询/重置/导出（对齐项目 toolbars 布局） -->
        <div class="toolbars mrgb5">
            <div class="buttons mrgb5">
                <div class="fl">
                    <el-button v-if="canManage" class="mrgr5 mrgb5" type="primary" size="medium" @click="edit()"><i class="fa fa-plus"></i> 新增绑定</el-button>
                    <import-button v-if="canManage" class="mrgb5" label="导入绑定保险" :handler="bindingApi.import" @complete="load"></import-button>
                    <el-button v-if="canLogs" class="mrgb5" size="medium" @click="$refs.logs.open(valVehicleDataChangeEntityTypeInsurance(), '')"><i class="fa fa-file-text-o"></i> 变更日志</el-button>
                    <el-button class="mrgb5" size="medium" @click="helping = true"><i class="fa fa-question-circle-o"></i> 功能说明</el-button>
                </div>
                <div class="fr">
                    <el-input class="c-el-input mrgr5 mrgb5" size="medium" clearable v-model.trim="query.chassisNo" placeholder="车架号" @clear="search"></el-input>
                    <el-input class="c-el-input mrgr5 mrgb5" size="medium" clearable v-model.trim="query.policyNumber" placeholder="保单号" @clear="search"></el-input>
                    <el-input class="c-el-input mrgr5 mrgb5" size="medium" clearable v-model.trim="query.keywords" placeholder="车架号 / 保单号关键词" @clear="search"></el-input>
                    <el-select class="c-el-input short-input mrgr5 mrgb5" size="medium" v-model="query.currentOnly" placeholder="绑定范围" @change="search">
                        <el-option label="全部历史" :value="false"></el-option>
                        <el-option label="当前有效" :value="true"></el-option>
                    </el-select>
                    <el-button class="mrgb5" type="primary" size="medium" @click="search()"><i class="fa fa-search"></i> 查询</el-button>
                    <el-button class="mrgb5" size="medium" @click="reset"><i class="fa fa-undo"></i> 重置</el-button>
                    <!-- 导出保险：按当前筛选条件导出车架↔保单绑定关系（当前有效 / 全部历史两种范围） -->
                    <el-dropdown v-if="canExport" class="mrgl5 mrgr5 mrgb5" trigger="click" @command="exportInsurance">
                        <el-button class="mrgb5" type="warning" size="medium" :loading="exporting"><i class="fa fa-sign-out"></i> 导出保险 <i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="current">当前有效</el-dropdown-item>
                            <el-dropdown-item command="all">全部历史</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="clearb"></div>
            </div>
        </div>
        <div>
            <el-table v-loading="loading" :data="rows" style="width: 100%" border size="medium" row-key="id">
                <el-table-column prop="chassisNo" label="车架号" min-width="190" show-overflow-tooltip />
                <el-table-column prop="policyNumber" label="保单号" min-width="190" show-overflow-tooltip />
                <el-table-column prop="company" label="保险公司" min-width="140" show-overflow-tooltip><template slot-scope="scope">{{ scope.row.company || '-' }}</template></el-table-column>
                <el-table-column prop="insuranceArea" label="保险区域" min-width="140" show-overflow-tooltip><template slot-scope="scope">{{ scope.row.insuranceArea || '-' }}</template></el-table-column>
                <el-table-column label="绑定开始" width="110"><template slot-scope="scope">{{ date(scope.row.startDate) }}</template></el-table-column>
                <el-table-column label="绑定结束" width="110"><template slot-scope="scope">{{ date(scope.row.endDate) }}</template></el-table-column>
                <el-table-column label="有效截止" width="110"><template slot-scope="scope">{{ date(scope.row.effectiveEndDate) }}</template></el-table-column>
                <el-table-column label="状态" width="95"><template slot-scope="scope"><el-tag size="medium" :type="scope.row.isActive ? 'success' : 'info'">{{ scope.row.isActive ? '当前有效' : '非当前' }}</el-tag></template></el-table-column>
                <el-table-column label="操作" width="100" :fixed="assetMobile ? false : 'right'">
                    <template slot-scope="scope">
                        <!-- 行内操作统一收纳进"更多"下拉（对齐项目操作列惯例） -->
                        <el-dropdown trigger="click">
                            <el-button type="primary" plain size="mini">更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-if="canManage" @click.native="edit(scope.row)">编辑绑定</el-dropdown-item>
                                <el-dropdown-item v-if="canManage" @click.native="openEnd(scope.row)">结束绑定</el-dropdown-item>
                                <el-dropdown-item v-if="canManage" @click.native="remove(scope.row)">删除绑定</el-dropdown-item>
                                <el-dropdown-item v-if="canLogs" @click.native="showLogs(scope.row)">变更日志</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination background :current-page.sync="query.page" :page-size.sync="query.size" :page-sizes="appPageSizes" layout="total, sizes, prev, pager, next, jumper" :total="total" @current-change="load" @size-change="search"></el-pagination>
            </div>
        </div>
        <el-dialog :title="form.id ? '编辑绑定' : '新增绑定'" :visible.sync="editing" append-to-body custom-class="c-el-dialog asset-dialog asset-dialog--binding" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small" @submit.native.prevent="save">
                <el-form-item label="车架号" prop="chassisNo"><el-input v-model.trim="form.chassisNo" :disabled="!!form.id" :maxlength="32" /></el-form-item>
                <el-form-item label="保单号" prop="policyNumber">
                    <el-select v-model="form.policyNumber" :disabled="!!form.id" filterable remote :remote-method="searchPolicies" :loading="policyLoading" @change="changePolicy">
                        <el-option v-for="item in policies" :key="item.id || item.policyNumber" :label="item.policyNumber" :value="item.policyNumber" />
                    </el-select>
                </el-form-item>
                <el-form-item label="保险区域"><el-input v-model.trim="form.insuranceArea" :maxlength="200" /></el-form-item>
                <el-form-item label="开始日期" prop="startDate"><el-date-picker v-model="form.startDate" :disabled="!!form.id" type="date" value-format="yyyy-MM-dd" /></el-form-item>
                <el-form-item label="结束日期" prop="endDate"><el-date-picker v-model="form.endDate" type="date" value-format="yyyy-MM-dd" clearable /></el-form-item>
            </el-form>
            <span slot="footer"><el-button :disabled="saving" @click="editing = false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存</el-button></span>
        </el-dialog>
        <el-dialog title="结束绑定" :visible.sync="ending" append-to-body custom-class="c-el-dialog asset-dialog asset-dialog--ending" :close-on-click-modal="false">
            <el-date-picker v-model="endDate" type="date" value-format="yyyy-MM-dd" :clearable="false" />
            <span slot="footer"><el-button :disabled="saving" @click="ending = false">取消</el-button><el-button type="primary" :loading="saving" @click="endBinding">确认结束</el-button></span>
        </el-dialog>
        <change-logs ref="logs" />
        <el-dialog title="车架保险功能说明" :visible.sync="helping" append-to-body custom-class="c-el-dialog asset-dialog asset-dialog--help">
            <div class="asset-help">
                <p>用途：管理全部"车架↔保单"保险绑定关系，车架号不要求存在于车架档案，可单独维护与删除。</p>
                <p>筛选：车架号、保单号为精确匹配，关键词模糊匹配两者；绑定范围可选全部历史或仅当前有效。</p>
                <p>导入绑定保险：按车架号+保单号写入绑定（开始日期留空取保单开始日期，录错可就地修正），需保单已存在。</p>
                <p>导出保险：按当前筛选条件导出"车架↔保单"绑定关系（当前有效 / 全部历史两种范围），JSON 可直接回导。</p>
                <p>结束绑定：写结束日期保留记录；删除绑定：物理删除且不再保留该条历史，请谨慎操作。</p>
            </div>
            <span slot="footer"><el-button type="primary" @click="helping = false">知道了</el-button></span>
        </el-dialog>
    </div>
</template>

<script>
    // 车架保险台账页（车架数据-车架保险页签）：全部车架保险绑定的查询、增删改、结束、导入导出
    import saveAs from 'file-saver'
    import moment from 'moment'
    import { bindingApi, policyApi, assetPermission } from '@/api/vehicleData'
    import permission from '@/mixins/permission'
    import enumConfigs from '@/mixins/enumConfigs'
    import ImportButton from './ImportButton'
    import ChangeLogs from './ChangeLogs'
    import assetResponsive from './assetResponsive'

    export default {
        components: { ImportButton, ChangeLogs },
        mixins: [permission, assetResponsive, enumConfigs],
        data: () => ({
            bindingApi, exporting: false, editing: false, ending: false, saving: false, helping: false, policyLoading: false,
            query: { page: 1, size: window.$common.appPageSize, chassisNo: '', policyNumber: '', keywords: '', currentOnly: false },
            rows: [], total: 0, loading: false, requestNumber: 0,
            policies: [], form: {}, endingRow: null, endDate: '',
            rules: {
                chassisNo: [{ required: true, message: '请输入车架号', trigger: 'blur' }],
                policyNumber: [{ required: true, message: '请选择保单', trigger: 'change' }],
                startDate: [{ required: true, message: '请选择开始日期', trigger: 'change' }]
            }
        }),
        computed: {
            canManage() { return this.hasSpecialRole(assetPermission('VehiclePolicyManage')) },
            canExport() { return this.hasSpecialRole(assetPermission('VehicleInsuranceExport')) },
            canLogs() { return this.hasSpecialRole(assetPermission('VehicleDataChangeLog')) }
        },
        mounted() { this.load() },
        methods: {
            date(value) { return value ? String(value).slice(0, 10) : '-' },
            params() {
                const params = { ...this.query }
                Object.keys(params).forEach(key => { if (params[key] === '' || params[key] == null) delete params[key] })
                return params
            },
            search() { this.query.page = 1; this.load() },
            reset() { this.query = { page: 1, size: window.$common.appPageSize, chassisNo: '', policyNumber: '', keywords: '', currentOnly: false }; this.load() },
            async load() {
                const requestNumber = ++this.requestNumber
                this.loading = true
                try {
                    const result = await bindingApi.list(this.params())
                    if (requestNumber !== this.requestNumber) return
                    this.rows = result.items || []
                    this.total = Number(result.totalCount || 0)
                    if (!this.rows.length && this.query.page > 1 && this.total) { this.query.page--; return this.load() }
                } catch (_) {
                    if (requestNumber === this.requestNumber) { this.rows = []; this.total = 0 }
                } finally { if (requestNumber === this.requestNumber) this.loading = false }
            },
            async searchPolicies(keywords) {
                this.policyLoading = true
                try {
                    const result = await policyApi.list({ keywords, page: 1, size: 100 })
                    this.policies = result.items || []
                    if (this.form.policyNumber && !this.policies.some(p => p.policyNumber === this.form.policyNumber)) this.policies.unshift({ policyNumber: this.form.policyNumber })
                } catch (_) { this.policies = [] } finally { this.policyLoading = false }
            },
            edit(row) {
                this.form = row ? { ...row, startDate: row.startDate ? this.date(row.startDate) : null, endDate: row.endDate ? this.date(row.endDate) : null } : { chassisNo: '', policyNumber: '', insuranceArea: '', startDate: null, endDate: null }
                this.policies = this.form.policyNumber ? [{ policyNumber: this.form.policyNumber }] : []
                this.editing = true
                this.$nextTick(() => this.$refs.form.clearValidate())
                this.searchPolicies(this.form.policyNumber)
            },
            changePolicy(value) {
                const policy = this.policies.find(item => item.policyNumber === value)
                if (policy && policy.startDate) this.form.startDate = this.date(policy.startDate)
            },
            async save() {
                if (this.saving) return
                const valid = await this.$refs.form.validate().catch(() => false)
                if (!valid) return
                if (this.form.endDate && this.form.endDate < this.form.startDate) return this.$message.error('结束日期不能早于开始日期')
                this.saving = true
                try {
                    const { chassisNo, policyNumber, insuranceArea, startDate, endDate } = this.form
                    const input = { chassisNo, policyNumber, insuranceArea, startDate, endDate: endDate || null }
                    if (this.form.id) await bindingApi.update(this.form.id, input)
                    else await bindingApi.create(input)
                    this.editing = false
                    this.$message.success('绑定已保存')
                    await this.load()
                    const parallel = await bindingApi.list({ chassisNo, currentOnly: true, page: 1, size: 1 })
                    if (Number(parallel.totalCount) > 1) this.$message.warning('该车架有多个当前有效绑定，请核对重复投保情况')
                } catch (_) { /* 请求层展示保存失败原因，保留表单。 */ } finally { this.saving = false }
            },
            openEnd(row) { this.endingRow = row; this.endDate = moment().format('YYYY-MM-DD'); this.ending = true },
            async endBinding() {
                if (this.saving || !this.endDate) return
                if (this.endDate < this.date(this.endingRow.startDate)) return this.$message.error('结束日期不能早于开始日期')
                this.saving = true
                try {
                    await bindingApi.end(this.endingRow.id, this.endDate)
                    this.ending = false
                    this.$message.success('绑定结束日期已更新')
                    this.load()
                } catch (_) { /* 请求层展示错误。 */ } finally { this.saving = false }
            },
            async remove(row) {
                try {
                    await this.$confirm(`确认删除车架 ${row.chassisNo} 与保单 ${row.policyNumber} 的这条绑定？删除后不再保留该绑定历史。`, '删除绑定', { type: 'warning' })
                    await bindingApi.remove(row.id)
                    this.$message.success('绑定已删除')
                    this.load()
                } catch (_) { /* 取消和接口错误均保留列表。 */ }
            },
            // 车架保险日志以车架号为业务键精确查询
            showLogs(row) { this.$refs.logs.open(this.valVehicleDataChangeEntityTypeInsurance(), row.chassisNo) },
            async exportInsurance(scope) {
                this.exporting = true
                try {
                    saveAs(await bindingApi.export({ ...this.params(), currentOnly: scope === 'current' }), `车架保险-${scope === 'current' ? '当前有效' : '全部历史'}.json`)
                } catch (_) { /* 请求层展示错误。 */ } finally { this.exporting = false }
            }
        }
    }
</script>
